"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTetherDefaultProps = getTetherDefaultProps;
exports.getTetherOptions = getTetherOptions;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ = require("_");

var RAW_TETHER_PROPS = ['classes', 'classPrefix', 'constraints', 'optimizations', 'targetModifier'];

function getTetherDefaultProps() {
  return {
    offsetHoriz: 0,
    offsetVert: 0,
    targetOffsetHoriz: 0,
    targetOffsetVert: 0,
    targetAttachmentHoriz: 'auto',
    targetAttachmentVert: 'auto'
  };
}

function offsetStr(vert, horiz) {
  if (typeof vert === 'number') {
    vert = vert + 'px';
  }

  if (typeof horiz === 'number') {
    horiz = horiz + 'px';
  }

  return vert + " " + horiz;
}

function getTetherOptions(props, element, target) {
  return (0, _extends2.default)({
    attachment: props.attachmentVert + " " + props.attachmentHoriz,
    element: element,
    enabled: true,
    target: target,
    offset: offsetStr(props.offsetVert, props.offsetHoriz),
    targetAttachment: props.targetAttachmentVert + " " + props.targetAttachmentHoriz,
    targetOffset: offsetStr(props.targetOffsetVert, props.targetOffsetHoriz)
  }, (0, _.pick)(props, RAW_TETHER_PROPS));
}